import styles from './brochure.module.sass'

import Button from '../basic/button'
import Image from '../basic/image'

function Brochure(props) {
	let fields = props.fields

	return <div className={styles.brochure}>
		<h1>{fields.title}</h1>
		<div className={styles.content_wrapper}>
			<div className={styles.sidebar}>
				{fields.image?.url && 
					<div className={styles.image_wrapper} onClick={fields.attachment.url ? () => window.open(fields.attachment.url, '_blank') : null}>
						<Image {...fields.image} className={styles.image}/>
					</div>
				}
				<Button fields={{button: {url: fields.attachment.url, title: 'Download', target: '_blank'}}} className={styles.button}>Download</Button>
			</div>
			<div className={styles.content} dangerouslySetInnerHTML={{__html: fields.content}}></div>
		</div>
	</div>
}

export default Brochure